import React from 'react';

export function GenieLogo({ className = '' }: { className?: string }) {
  return (
    <svg 
      width="20" 
      height="20" 
      viewBox="0 0 20 20" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M14.9976 0C14.9976 2.76357 12.757 4.99987 9.99838 4.99987C12.7616 4.99987 14.9976 7.24073 14.9976 9.99975C14.9976 7.23618 17.2381 4.99987 19.9968 4.99987C17.2336 4.99987 14.9976 2.75902 14.9976 0ZM14.9976 9.99975C14.9976 12.7633 12.757 14.9996 9.99838 14.9996C12.7616 14.9996 14.9976 17.2405 14.9976 19.9995C14.9976 17.2359 17.2381 14.9996 19.9968 14.9996C17.2336 14.9996 14.9976 12.7588 14.9976 9.99975ZM4.99919 0C4.99919 2.76357 2.75864 4.99987 0 4.99987C2.76319 4.99987 4.99919 7.24073 4.99919 9.99975C4.99919 7.23618 7.23973 4.99987 9.99838 4.99987C7.23519 4.99987 4.99919 2.75902 4.99919 0ZM4.99919 9.99975C4.99919 12.7633 2.75864 14.9996 0 14.9996C2.76319 14.9996 4.99919 17.2405 4.99919 19.9995C4.99919 17.2359 7.23973 14.9996 9.99838 14.9996C7.23519 14.9996 4.99919 12.7588 4.99919 9.99975Z" fill="currentColor"/>
    </svg>
  );
}
